import { defaultSkillClustersTerms } from 'Utils';
import { atom } from 'recoil';

export const recoilSkillClustersTerms = atom({
  key: 'skill clusters terms',
  default: defaultSkillClustersTerms,
});
